import guid from './guid';

// Shared helpers for the column/parameter editors (CustomUrlColumns,
// SortingParameters, ClassificationFields) that build a list of `{ id, key,
// ... }` rows from server-provided columns.

// A blank, draggable column row. `key` is a fresh guid so unsaved rows have a
// stable React key before they get a server id.
export const newColumn = () => ({
  key: guid(), header: '', columnType: '', name: '',
});

// Stamps each column with a stable `id`/`key` derived from `columnId`. When
// `fillEmptyWith` is given and the list is empty, seeds it with one row (the
// ClassificationFields behaviour). Mutates and returns `columns`.
export const processInitialColumns = (columns, columnId, fillEmptyWith) => {
  for (const column of columns) {
    column.id = columnId(column);
    column.key = column.id;
  }
  if (fillEmptyWith && columns.length < 1) columns.push(fillEmptyWith());
  return columns;
};
